import React, { useMemo } from 'react';
import { informationModal } from '../../Types/InformationModal';
import EditorString from '../EditorString/EditorString';
import Icon from '../Icon';

const InformationModal = (modal: informationModal) => {
  return (
    <div className="mb-4 rounded-lg border border-solid  border-warning-500 bg-warning-100 p-4 pb-5">
      {modal.title && (
        <div className="mb-1.5 flex items-center">
          <Icon className="mr-1.5 h-5 w-5" name="info" />
          <p className="text-lg font-medium leading-6">{modal.title}</p>
        </div>
      )}
      {modal.description?.value && (
        <EditorString value={modal.description.value} />
      )}
    </div>
  );
};

export default InformationModal;
